import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { BMI_Child_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import BMIChildrenTable from './BMIChildrenTable';
import SharedHelmet from "../Helmet";
const TITLE = 'BMI Body Mass Index Calculator (for Children) - Ideal Weight Calculator for Children';
const DESCRIPTION = 'Use the BMI (Body Mass Index) calculator for children to assess the health and weight of your children - the BMI calculator for children is a tool used to assess whether a child\'s weight is appropriate for their height, i.e., the ideal weight (BMI) for your child.';
const KEYWORDS = 'BMI for children, BMI calculation for children, BMI calculator for children, how to calculate BMI for children, ideal weight, BMI calculation formula for children, children\'s health indicators and body mass, knowing my child\'s BMI, healthy BMI for children, analyzing BMI and healthy weight for children, how to evaluate BMI for children';
const OG_URL = 'https://do-calculate.com/calculator/en/bmichildren/';
const apiEndpoint = `${SERVER_URL}/${BMI_Child_EndPoint}`;
function BMICalculator() {
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const calculateBMI = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ weight, height, age, gender }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '39px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The BMI (Body Mass Index) calculator for children is a tool used to assess whether a child's weight is appropriate for their height, i.e., the ideal weight (BMI) for your child. This calculator uses BMI categories used for children aged 2 to 20 years. The calculator takes into account age, gender, height, and weight to calculate the child's BMI. The child's BMI is presented as a percentage (centile), and the percentage indicates how the child's weight compares to other children of the same age and gender.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    BMI (Body Mass Index) for Children
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="height" className="form-label ms-2">Height</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="height"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="weightNumber" className="form-label ms-2">Weight</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">kg</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="age" className="form-label ms-2">Age</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="age"
                                        value={age}
                                        onChange={handleAgeChange}
                                        className="form-control"
                                        style={{ width: '75px' }}
                                        placeholder="6"
                                        min="2"
                                        max="20"
                                    />
                                    <span style={{ marginRight: '10px' }}>(between 2 and 20 years)</span>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Gender</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            id="male"
                                            checked={gender === "male"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="male">
                                            Male
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            id="female"
                                            checked={gender === "female"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="female">
                                            Female
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateBMI} disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Calculate'
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <BMIChildrenTable classification={classification}></BMIChildrenTable>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                        <div className="row">
                            <div className="col" >
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter all fields correctly. </div>}
                                {result && (
                                    <div>
                                        <h4>Results:</h4>
                                        <hr />
                                        <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                            <b> BMI (Body Mass Index):   </b>{result.bmi}  <label> kg/m²</label>
                                        </label>
                                        </div>
                                        <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                            <b> Classification:   </b> {result.classification}
                                        </label>
                                        </div>
                                        <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                            <b> Centile: </b>{result.centile}
                                        </label>
                                        </div>
                                        {result.weightNeeded !== 0 && (
                                            <div>
                                                <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                    <b> Healthy BMI Range: </b>{result.lowerHealthyBMI}  - {result.higherHealthyBMI} ( kg/m²)
                                                </label>
                                                </div>
                                                {result.weightNeeded > 0 && (
                                                    <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                        Gain: <b> "{result.weightNeeded}  kg"</b> to reach BMI <b> {result.lowerHealthyBMI} ( kg/m²) </b>
                                                    </label>
                                                    </div>
                                                )}
                                                {result.weightNeeded < 0 && (
                                                    <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                        Lose: <b> "{Math.abs(result.weightNeeded)}  kg"</b> to reach BMI <b> {result.higherHealthyBMI} ( kg/m²) </b>
                                                    </label>
                                                    </div>
                                                )}
                                                <div className="alert alert-warning">
                                                    <label>   If you wish to discuss your child's weight, talk to your child's school nurse or a general practitioner.
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Calculate Body Mass Index BMI (Children) - Ideal Weight for Child</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Calculate Body Mass Index BMI (Children) - Accurately Measure Your Child's Health and Weight</h2></u>
                                <p>
                                    The child's Body Mass Index (BMI) tells us whether their weight is appropriate for their height. Instead of using BMI categories used for adults, BMI for children is given as a percentile. Since children continue to grow until around age 20, their age and whether they are a boy or girl are also used to calculate the BMI percentile.
                                </p>
                                <p>
                                    For children and adolescents aged 2 to 20, the BMI calculator takes into account age, gender, as well as height and weight.
                                </p>
                                <p>
                                    The child's BMI is given as a "centile." The centile number indicates how the BMI compares with other children of the same age and gender as a percentage.
                                </p>
                                <div className='p-3 mb-2 bg-info  '>
                                    <p>
                                        For example, a girl in the seventy-fifth (75th) percentile means she is heavier than 75% of other girls of the same age.
                                    </p>
                                </div>
                                <p>
                                    In this calculator, we used the BMI categories for children and adolescents aged 2 to 20, recommended by the <u>"Centers for Disease Control and Prevention (CDC)"</u> of the United States National Public Health Agency, as mentioned in the previous table.
                                </p>
                                <h2 style={{ fontSize: '16px' }}>BMI Growth Charts for Children and Adolescents, Ages 2 to 20:</h2> <br />
                                Growth percentiles charts from the Centers for Disease Control and Prevention (CDC):
                                <ul>
                                    <li>
                                        <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c021.pdf">
                                            Male Chart
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c022.pdf">
                                            Female Chart
                                        </a>
                                    </li>
                                </ul>
                                <h2 style={{ fontSize: '16px' }}>Table of Data for BMI Charts for Age Used in this Calculator to Calculate Percentile:</h2>
                                <ul>
                                    <li>
                                        <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c023.pdf">
                                            Males
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c024.pdf">
                                            Females
                                        </a>
                                    </li>
                                </ul>
                                <div className='p-3 mb-2 bg-info '>
                                    These percentiles represent the child's BMI compared to American children who participated in national surveys from 1963-1965 to 1988-1994. We did not find BMI charts for children in Arab countries, so we relied on American data.
                                </div>
                                <br/>                                <b>Source:</b>
                                <a href="https://www.cdc.gov/bmi/faq/">
                                    Centers for Disease Control and Prevention - United States National Public Health Agency
                                </a> <br />
                                <b>Last Reviewed:</b>
                                07/06/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BMICalculator;
